import { Box, Typography } from "@mui/material";
import { usePriceFormat } from "hooks/formatting/usePriceFormat";
import { useTranslation } from "react-i18next";
import type { Maybe, Price } from "types";

export const OrderPriceSummary = ({ orderPrice }: { orderPrice: Maybe<Price> | undefined }) => {
	const { t } = useTranslation();
	const { formatPrice } = usePriceFormat();

	return (
		<>
			{orderPrice?.current ? (
				<Box display="flex" flexDirection="column">
					<Typography variant="promoHeader" textAlign="right">
						{t("order.summary.totalPrice")}
						{formatPrice(orderPrice.current, orderPrice.currency)}
					</Typography>
				</Box>
			) : null}
		</>
	);
};
